import { Box, Flex, Heading } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { AutoBrandEntity } from './AutoBrand.helpers';
import { Logo } from './Logo';
import Palette from './Palette';

export interface AutoBrandProps {
  brands?: AutoBrandEntity | null;
}

const Brands = function Brands({ brands }: AutoBrandProps) {
  const { t } = useTranslation('auto_brand', { useSuspense: false, keyPrefix: 'modals.autoBrand' });

  return (
    <Flex minW='22rem' minH='32rem' flexDirection={'column'} gap={4} padding={6} overflow='auto'>
      {brands?.logos && (
        <Box bg={'white'} borderRadius={6} w='100%' paddingX={4} paddingY={5} boxShadow='sm'>
          <>
            <Heading fontWeight='medium' fontSize={14}>
              {t('brandLogos')}
            </Heading>
            <Flex paddingTop={3} gap={4} flexWrap='wrap' justifyContent={'left'} alignContent='center'>
              {brands.logos.map((logo, key) => (
                <Logo key={key} logo={logo} />
              ))}
            </Flex>
          </>
        </Box>
      )}

      {brands?.colors && (
        <Box bg={'white'} borderRadius={6} w='100%' paddingX={4} paddingY={5} boxShadow='sm'>
          <>
            <Heading fontWeight='medium' fontSize={14}>
              {t('brandColors')}
            </Heading>
            <Flex paddingTop={3}>
              <Palette palettes={brands?.colors} />
            </Flex>
          </>
        </Box>
      )}
    </Flex>
  );
};

export default Brands;
